import axios from 'axios';

const studentconduct = {
    state: {  
		studentconducts : []
	},	
	mutations: {		
		studentconducts_success(state, payload){			
			state.studentconducts = payload	
		}	
	},
	actions: {
        getstudentconduct(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Studentconduct/Getstudentconduct', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {						
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},			
		getstudentconductbyid(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Studentconduct/Getstudentconductbyid', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},						
		studentconductregistration(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Studentconduct/Registerstudentconduct', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
        },        
	}
}

export default studentconduct